export const languageElements = {
  items: {
    "BUDAPEST-title": {
      hu: "BUDAPEST",
      de: "BUDAPEST",
      en: "BUDAPEST",
    },

    "BUDAPEST-descr": {
      hu: "Head Office",
      de: "Head Office",
      en: "Head Office",
    },

    "VIENNA-title": {
      hu: "Schwechat-Repülőtér",
      de: "Wien-Flughafen",
      en: "Vienna-Airport",
    },

    "VIENNA-descr": {
      hu: "Branch Office Austria",
      de: "Branch Office Austria",
      en: "Branch Office Austria",
    },

    "KOPER-title": {
      hu: "Koper",
      de: "Koper",
      en: "Koper",
    },

    "KOPER-descr": {
      hu: "Branch Office Koper",
      de: "Branch Office Koper",
      en: "Branch Office Koper",
    },
  },
};
